(function(){

  function getBaseSize() {
    return window.getComputedStyle(document.body).fontSize;
  }

  function applyTextSizes() {
    var base = getBaseSize();
    var px = parseFloat(base);

    /* Description + réponses FAQ : taille body */
    document.querySelectorAll(
      '.ph-desc-inner, .ph-desc-inner *, .ph-faq-a-inner, .ph-faq-a-inner *'
    ).forEach(function(el) {
      el.style.setProperty('font-size', base, 'important');
      el.style.setProperty('line-height', '1.75', 'important');
    });

    /* Questions FAQ : même taille body */
    document.querySelectorAll('.ph-faq-q').forEach(function(el) {
      el.style.setProperty('font-size', base, 'important');
    });

    /* H1/H2/H3 restent hiérarchiques */
    document.querySelectorAll('.ph-desc-inner h1,.ph-faq-a-inner h1').forEach(function(el){ el.style.setProperty('font-size',(px*1.8)+'px','important'); });
    document.querySelectorAll('.ph-desc-inner h2,.ph-faq-a-inner h2').forEach(function(el){ el.style.setProperty('font-size',(px*1.5)+'px','important'); });
    document.querySelectorAll('.ph-desc-inner h3,.ph-faq-a-inner h3').forEach(function(el){ el.style.setProperty('font-size',(px*1.25)+'px','important'); });
  }

  function initCollectionUI() {
    document.querySelectorAll('.ph-desc-toggle:not([data-ph-init])').forEach(function(btn) {
      btn.setAttribute('data-ph-init','1');
      var id = btn.id.replace('ph-toggle-','');
      var content = document.getElementById('ph-desc-' + id);
      if(!content) return;
      btn.addEventListener('click', function() {
        var open = content.classList.toggle('open');
        btn.classList.toggle('open', open);
        btn.setAttribute('aria-expanded', open);
        var label = btn.querySelector('span:first-child');
        if(label) label.textContent = open ? 'Masquer la description' : 'Voir la description';
        applyTextSizes();
      });
    });

    if(!document.querySelector('.ph-faq-header')) {
      var firstFaqBtn = document.querySelector('.ph-faq-q');
      if(firstFaqBtn) {
        var container = firstFaqBtn.parentElement;
        var header = document.createElement('div');
        header.className = 'ph-faq-header';
        header.innerHTML = '<span>Questions fr&eacute;quentes</span>';
        container.parentNode.insertBefore(header, container);
      }
    }

    document.querySelectorAll('.ph-faq-q:not([data-ph-init])').forEach(function(btn) {
      btn.setAttribute('data-ph-init','1');
      var answer = btn.nextElementSibling;
      if(!answer) return;
      btn.addEventListener('click', function() {
        var open = answer.classList.toggle('open');
        btn.classList.toggle('open', open);
        btn.setAttribute('aria-expanded', open);
        if(open) applyTextSizes();
      });
    });

    applyTextSizes();
  }

  if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionUI);
  } else {
    initCollectionUI();
  }
})();